// extracted by mini-css-extract-plugin
export default {"root":"MoneyDisplay_root__PSymx"};